// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  mediaMin,
  spacing,
  mediaMax,
  fontWeight,
  fontSize,
  isMediaMax,
} from 'presentations/views/styles';
import UserEventTypeTimeList from 'presentations/views/components/organisms/UserEventTypeTimeList';
import { DateTime, formatToDate } from 'infras/datetime';
import { gray02 } from 'presentations/views/styles/color';
import { TimeList } from 'presentations/api/helpers/event_type';

interface Props {
  selectedDate: DateTime | null;
  selectedDatetime: DateTime | null;
  timeList: TimeList;
  onTimeSelect?: any;
  isLoading?: boolean;
  timeZone: string;
  color: string;
  isLightColor: boolean;
  hiddenTimeZone?: boolean;
  isRevealGuestUser: boolean;
  isShowViewerCalendar: boolean;
  isHostDiagnosticMode?: boolean;
  onClickBlockTime?: Function;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const isTablet = isMediaMax('tablet');
  return (
    <PickerContainer>
      <StyledTimeList>
        <TimeListContainer>
          <DateSelected>
            {props.selectedDate?.toFormat(t('date format'))}
          </DateSelected>
          <UserEventTypeTimeList
            isFullHeight={isTablet}
            selectedDate={props.selectedDate}
            selectedDatetime={props.selectedDatetime}
            onSelect={props.onTimeSelect}
            timeList={props.timeList}
            isLoading={props.isLoading}
            timeZone={props.timeZone}
            color={props.color}
            isLightColor={props.isLightColor}
            isRevealGuestUser={props.isRevealGuestUser}
            isShowViewerCalendar={props.isShowViewerCalendar}
            isHostDiagnosticMode={props.isHostDiagnosticMode}
            onClickBlockTime={props.onClickBlockTime}
          />
          {!props.hiddenTimeZone && (
            <TimeZoneSelected>{props.timeZone}</TimeZoneSelected>
          )}
        </TimeListContainer>
      </StyledTimeList>
    </PickerContainer>
  );
}

const PickerContainer = styled.div`
  ${mediaMin.tablet} {
    display: flex;
    align-items: top;
  }
`;
const StyledTimeList = styled.div`
  display: block;
  width: 100%;
  height: auto;
  overflow: auto;
`;
const TimeListContainer = styled.div``;

const DateSelected = styled.div`
  margin-bottom: ${spacing(24)};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  text-align: center;
  ${mediaMax.tablet} {
    font-size: ${fontSize(22)};
  }
`;
const TimeZoneSelected = styled.div`
  margin: ${spacing(16)} 0;
  color: ${gray02};
  text-align: center;
`;
